import React from "react";
import Modal from "react-modal";

const RestaurantModal = ({
  isOpen,
  restaurant,
  closeModal,
  openImageModal,
}) => {
  const restaurantName = restaurant?.restaurantName || "N/A";
  const ownerName = restaurant?.ownerName || "N/A";
  const managerName = restaurant?.managerName || "N/A";
  const email = restaurant?.email || "N/A";
  const mobileNumber = restaurant?.mobileNumber || "N/A";
  const address = restaurant?.location?.address || "N/A";
  const isPremium = restaurant?.premiumAccess?.isPremium ? "Yes" : "No";
  const aboutRestaurant = restaurant?.aboutRestaurant || {};
  const foodTypes = aboutRestaurant?.typesOfFood?.join(", ") || "N/A";
  const facilities = aboutRestaurant?.facilities?.join(", ") || "N/A";
  const avgPriceTwo = aboutRestaurant?.avgPriceTwo
    ? `₹${aboutRestaurant.avgPriceTwo}`
    : "N/A";
  const ratings = restaurant?.averageRating || {};
  const overallAvgRating = restaurant?.overallAverageRating;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="restaurant-modal"
    >
      <div className="modal-header">
        <h2>{restaurantName}</h2>
      </div>

      <div className="modal-content">
        <p>
          <strong>Owner Name:</strong> {ownerName}
        </p>
        <p>
          <strong>Manager Name:</strong> {managerName}
        </p>
        <p>
          <strong>Email:</strong> {email}
        </p>
        <p>
          <strong>Mobile:</strong> {mobileNumber}
        </p>
        <p>
          <strong>Address:</strong> {address}
        </p>
        <p>
          <strong>Premium:</strong> {isPremium}
        </p>
        <div className="image-buttons">
          <button
            onClick={() =>
              openImageModal(restaurant?.images || [], "Gallery Images")
            }
            disabled={
              !(
                restaurant?.images &&
                restaurant?.images.length > 0 &&
                !(
                  Array.isArray(restaurant?.images) &&
                  restaurant?.images.length === 1 &&
                  restaurant?.images[0] === ""
                )
              )
            }
          >
            View Gallery
          </button>
          <button
            onClick={() =>
              openImageModal([restaurant?.bannerImage], "Banner Image")
            }
            disabled={!restaurant?.bannerImage}
          >
            View Banner
          </button>
          <button
            onClick={() =>
              openImageModal(restaurant?.menuImages || [], "Menu Images")
            }
            disabled={
              !(
                restaurant?.menuImages &&
                restaurant?.menuImages.length > 0 &&
                !(
                  Array.isArray(restaurant?.menuImages) &&
                  restaurant?.menuImages.length === 1 &&
                  restaurant?.menuImages[0] === ""
                )
              )
            }
          >
            View Menu
          </button>
        </div>
        <div className="details-container">
          <h3>About Restaurant</h3>
          <p>{aboutRestaurant?.about || "N/A"}</p>

          <div className="detail-row">
            <div className="detail-label">Types of Food:</div>
            <div className="detail-value">{foodTypes}</div>
          </div>
          <div className="detail-row">
            <div className="detail-label">Facilities:</div>
            <div className="detail-value">{facilities}</div>
          </div>
          <div className="detail-row">
            <div className="detail-label">Avg Price for Two:</div>
            <div className="detail-value">{avgPriceTwo}</div>
          </div>
        </div>
        <h3>Average Ratings</h3>
        <div className="ratings-container">
          <div className="rating-row">
            <strong>Overall Average Rating:</strong>{" "}
            {overallAvgRating.toFixed(2)}
          </div>
          <div className="rating-row">
            <strong>Food:</strong> {ratings?.food}
          </div>
          <div className="rating-row">
            <strong>Service:</strong> {ratings?.service}
          </div>
          <div className="rating-row">
            <strong>Ambience:</strong> {ratings?.ambience}
          </div>
          <div className="rating-row">
            <strong>Washroom Hygiene:</strong> {ratings?.washroomHygiene}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="close-modal-btn" onClick={closeModal}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default RestaurantModal;
